<div id="downloadShipmentLabelsModal" class="downloadShipmentLabelsModal" uk-modal>
  <div class="uk-modal-dialog">
    <button class="uk-modal-close-default" type="button" uk-close></button>

    <div class="uk-modal-header">
      <h2 class="uk-modal-title">{{'paper_size' | translate}}</h2>
    </div>
    <div class=" uk-modal-body">

      <a (click)="downloadFile( 'dl')"
         class="uk-button uk-button-primary uk-width-1-1"
      >
        297 × 210
      </a>
      <a (click)="downloadFile( '100150')"
         class="uk-button uk-button-primary uk-width-1-1 uk-margin-top"
      >
        100 x 150
      </a>

      <a (click)="addNextShipment()"
         class="uk-button uk-button-danger uk-width-1-1 uk-margin-top"
      >
        {{"add_next_parcel" | translate}}
      </a>

    </div>
  </div>
</div>
